import { Form, Input, Select } from 'antd';
import BaseModalStrategy from './BaseModalStrategy';
import { t } from '../../../i18n/i18n';
import { TRIGGER_TEMPLATES } from '../../../constants/alkymation';

const { Option } = Select;

class ConditionCheckStrategy extends BaseModalStrategy {
  // eslint-disable-next-line class-methods-use-this
  renderBody() {
    const comparisonOperators = [
      { value: '>', label: `> (${t('ALKYMATION_OPERATOR_GREATER_THAN')})` },
      { value: '>=', label: `>= (${t('ALKYMATION_OPERATOR_GREATER_THAN_OR_EQUAL')})` },
      { value: '<', label: `< (${t('ALKYMATION_OPERATOR_LESS_THAN')})` },
      { value: '<=', label: `<= (${t('ALKYMATION_OPERATOR_LESS_THAN_OR_EQUAL')})` },
      { value: '==', label: `== (${t('ALKYMATION_OPERATOR_EQUAL')})` },
      { value: '===', label: `=== (${t('ALKYMATION_OPERATOR_STRICT_EQUAL')})` },
      { value: '!=', label: `!= (${t('ALKYMATION_OPERATOR_NOT_EQUAL')})` },
      { value: '!==', label: `!== (${t('ALKYMATION_OPERATOR_STRICT_NOT_EQUAL')})` },
    ];

    // Check if previous node is webhook-screening-complete
    const isPreviousNodeScreeningWebhook =
      this.previousNode?.templateId === TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE ||
      this.previousNode?.template?.templateId === TRIGGER_TEMPLATES.WEBHOOK_SCREENING_COMPLETE;

    const screeningScoreOptions = {
      screeningScore: t('SCREENING_DATA_OPTION_SCORE'),
    };

    return (
      <>
        <Form.Item
          name="leftExpression"
          label={t('ALKYMATION_CONDITION_LEFT_EXPRESSION')}
          rules={[
            {
              required: true,
              message: t('ALKYMATION_CONDITION_LEFT_EXPRESSION_REQUIRED'),
            },
          ]}
          help={t('ALKYMATION_CONDITION_LEFT_EXPRESSION_HELP')}
        >
          {isPreviousNodeScreeningWebhook ? (
            <Select placeholder={t('ALKYMATION_CONDITION_LEFT_EXPRESSION_PLACEHOLDER')}>
              {Object.entries(screeningScoreOptions).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          ) : (
            <Input placeholder={t('ALKYMATION_CONDITION_LEFT_EXPRESSION_PLACEHOLDER')} />
          )}
        </Form.Item>

        <Form.Item
          name="operator"
          label={t('ALKYMATION_CONDITION_OPERATOR')}
          rules={[
            {
              required: true,
              message: t('ALKYMATION_CONDITION_OPERATOR_REQUIRED'),
            },
          ]}
          help={t('ALKYMATION_CONDITION_OPERATOR_HELP')}
        >
          <Select placeholder={t('ALKYMATION_CONDITION_OPERATOR_PLACEHOLDER')}>
            {comparisonOperators?.map((op) => (
              <Option key={op?.value} value={op?.value}>
                {op?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="rightExpression"
          label={t('ALKYMATION_CONDITION_RIGHT_EXPRESSION')}
          rules={[
            {
              required: true,
              message: t('ALKYMATION_CONDITION_RIGHT_EXPRESSION_REQUIRED'),
            },
          ]}
          help={t('ALKYMATION_CONDITION_RIGHT_EXPRESSION_HELP')}
        >
          <Input placeholder={t('ALKYMATION_CONDITION_RIGHT_EXPRESSION_PLACEHOLDER')} />
        </Form.Item>

        <div className="alert alert-info mt-3">
          <strong>{t('ALKYMATION_CONDITION_EXAMPLE_TITLE')}</strong>
          <br />
          {t('ALKYMATION_CONDITION_EXAMPLE_TEXT')}
        </div>
      </>
    );
  }
}

export default ConditionCheckStrategy;
